import { AdminDocuments } from "components/AdminDocuments"
import Breadcrumbs from "components/Breadcrumbs"
import { Header } from "components/Page"
import Surface from "components/Surface"
import { css, cx } from "@emotion/css"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"
import { SelectAgency } from "../components/SelectAgency"
import { useAgencyId } from "hooks/useAgencyId"

const styles = {
  main: css`
    padding: var(--spacing-xxl-2);
    padding-top: var(--spacing-m);
  `,
  tabContent: css`
    padding-left: var(--spacing-m);
    padding-right: var(--spacing-m);
    padding-bottom: var(--spacing-m);
  `,
  surface: css`
    padding: var(--spacing-xxl-2) 0px 0px;
  `,
  documents: css`
    display: flex;
    grid-column-gap: var(--spacing-xxl-2);
  `,
}

function AgencyDocuments() {
  const { t } = useI18n()
  const { hasAuthority } = useAuthenticated()
  const { agencyId } = useAgencyId()

  const documentTypes = [
    {
      label: t("agency.documents.logo"),
      value: t("agency.documents.logo"),
    },
    {
      label: t("agency.documents.other"),
      value: t("agency.documents.other"),
    },
  ]

  return (
    <div className={styles.main}>
      <Breadcrumbs
        section={t("nav.admin")}
        current={t("nav.agency.documents")}
      />
      <Header label={t("nav.admin.documents")}>
        <SelectAgency />
      </Header>
      <Surface size={"ghost"} className={styles.surface}>
        <div className={cx(styles.tabContent, styles.documents)}>
          {!!agencyId ? (
            <AdminDocuments
              documentTypes={documentTypes}
              type="agency"
              ownerEntityId={agencyId}
              disabled={!hasAuthority(["AUTH_MANAGE_AGENCY_DOCUMENT"])}
            />
          ) : null}
        </div>
      </Surface>
    </div>
  )
}

export default AgencyDocuments
